import { render, staticRenderFns } from "./UiPaginations.vue?vue&type=template&id=5405b510&"
import script from "./UiPaginations.vue?vue&type=script&lang=js&"
export * from "./UiPaginations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports